import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Hamburger from '../../../assets/hamburger.svg';
import useResponsive from '../../hooks/useResponsive';
import { SidebarActionCreators } from '../../redux/actions/creators';
import { SidebarSelectors } from '../../redux/selectors';
import TopBar from './TopBar';

import styles from '../../styles/views/components/ResponsiveTopBar.module.scss';

const ResponsiveTopBar = ({ title, elementsAtRight }) => {
  const dispatch = useDispatch();
  const { isTablet, isMobile } = useResponsive();

  const isSidebarExpanded = useSelector(SidebarSelectors.selectIsSidebarExpanded);
  const isResponsiveTopBarVisible = (isMobile || isTablet) && !isSidebarExpanded;

  const expandSidebar = useCallback(() => {
    dispatch(SidebarActionCreators.expandSidebar());
  }, [dispatch]);

  const topBarElementsAtLeft = () => (
    <div className={styles.left}>
      <Hamburger onClick={expandSidebar} />
      <div className={styles.title}>
        {title}
      </div>
    </div>
  );

  return (
    isResponsiveTopBarVisible && (
      <div className={styles.responsiveTopBar}>
        <TopBar
          elementsAtLeft={topBarElementsAtLeft()}
          elementsAtMiddle={null}
          elementsAtRight={elementsAtRight}
        />
      </div>
    )
  );
};

ResponsiveTopBar.propTypes = {
  title: PropTypes.string.isRequired,
  elementsAtRight: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]),
};

ResponsiveTopBar.defaultProps = {
  elementsAtRight: [],
};

export default ResponsiveTopBar;
